// Public, unauthenticated demo scan page; auth guard exempts /public/*; server enforces public_available flag.
import { ScanReportView } from "@/components/targets/scans/ScanReportView";
import { ScanViewProvider } from "@/components/targets/scans/ScanViewContext";
import { RouteShell } from "@/design-system";
import { useScanStream } from "@/hooks/useScanStream";
import { useScanTabs } from "@/stores/scan-tabs";
import { track } from "@/lib/analytics";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/public/scans/$scanDisplayId")({
  staticData: { shell: "public" },
  component: PublicScanPage,
});

function PublicScanPage() {
  const { scanDisplayId } = Route.useParams();

  // isPublic=true → unauthenticated /api/scans/public/:displayId/stream; fold reads ids off the payload.
  const timeline = useScanStream(scanDisplayId, true);
  const { scan, isLive, isPending, error, report } = timeline;

  const resetTabs = useScanTabs((s) => s.reset);
  useEffect(() => {
    resetTabs();
  }, [scanDisplayId, resetTabs]);

  useEffect(() => {
    track({ event: "public_scan_viewed" });
  }, []);

  return (
    <ScanViewProvider isPublic>
      <RouteShell
        isPending={isPending}
        error={error}
        loadingLabel="Loading scan report…"
      >
        {scan && report ? (
          <ScanReportView
            scanId={scan.id}
            report={report}
            checks={timeline.checks}
            rawEvents={timeline.rawEvents}
            isLive={!!isLive}
          />
        ) : null}
      </RouteShell>
    </ScanViewProvider>
  );
}
